import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=33228d6d&scoped=true"
import script from "./my-table.vue?vue&type=script&lang=js"
export * from "./my-table.vue?vue&type=script&lang=js"
import style0 from "./my-table.vue?vue&type=style&index=0&id=33228d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33228d6d",
  null
  
)

export default component.exports